import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { SpatialQueryService } from '../../../services/spatialQuery.service';
import { ThemeService } from '../../../services/theme.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { BaseComponent } from '../../base.component';
var Graphic;
var LassoToolComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LassoToolComponent, _super);
    function LassoToolComponent(_vcr, layerService, spatialQueryService, toSqlStringService, themeService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.spatialQueryService = spatialQueryService;
        _this.toSqlStringService = toSqlStringService;
        _this.themeService = themeService;
        _this.r = 255;
        _this.g = 165;
        _this.b = 0; // Orange color
        _this.featureLayerColor = [_this.r, _this.g, _this.b];
        _this.sketchToolType = 'polygon';
        _this.sketchCreationMode = 'single';
        _this.sketchDefaultCreateOptions = { mode: 'hybrid' };
        _this.sketchDefaultUpdateOptions = { tool: 'transform' };
        _this.spatialRelationships = ['Intersects', 'Contains'];
        _this.geoprocessingLayers = [];
        _this.spatialQueryType = 'feature';
        _this.spatialRelationship = _this.spatialRelationships[0];
        _this.runSpatialQueryOnSketchComplete = true;
        _this.reactivateSketchOnSketchComplete = true;
        _this.displayFeatureGraphicsAfterSpatialQuery = true;
        _this.oncomplete = new EventEmitter();
        _this.drawEnd = new EventEmitter();
        _this._isActivated = false;
        _this.activate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addFeaturesLayerToMapIfNotPresent()];
                    case 1:
                        _a.sent();
                        this.sketchTool.mapView = this.mapView;
                        this.sketchTool.creationMode = this.sketchCreationMode;
                        this.sketchTool.defaultCreateOptions = this.sketchDefaultCreateOptions;
                        this.sketchTool.defaultUpdateOptions = this.sketchDefaultUpdateOptions;
                        if (this.containerElement) {
                            this.sketchTool.containerElement = this.containerElement;
                        }
                        else {
                            this.sketchTool.containerElement = this.hostElement;
                        }
                        this.sketchTool.activate(this.sketchToolType);
                        this._isActivated = true;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.deactivate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this._isActivated = false;
                this.sketchTool.deactivate();
                return [2 /*return*/];
            });
        }); };
        _this.destroy = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_1, _a, _b, _c, layer;
            return tslib_1.__generator(this, function (_d) {
                this.deactivate();
                this.clearFeatureResults();
                if (this.featuresLayer) {
                    this.featuresLayer.removeAll();
                    this.mapView.map.remove(this.featuresLayer);
                }
                if (this.geoprocessingLayers.length) {
                    try {
                        for (_b = tslib_1.__values(this.geoprocessingLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                            layer = _c.value;
                            this.mapView.map.remove(layer);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    this.geoprocessingLayers = [];
                }
                this.sketchTool.destroy();
                return [2 /*return*/];
            });
        }); };
        _this.clearFeatureResults = function () {
            if (_this.featuresLayer) {
                _this.featuresLayer.removeAll();
            }
            _this.layerFeatureResults = null;
            _this.removeGeoProcessingLayers();
        };
        _this.runSpatialQuery = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var ex_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.layerFeatureResults) {
                            this.layerFeatureResults = [];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!(this.spatialQueryType === 'feature')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.runFeatureQuery()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.runGeoprocessingQuery()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.oncomplete.emit(true);
                        return [3 /*break*/, 7];
                    case 6:
                        ex_1 = _a.sent();
                        this.oncomplete.emit(false);
                        return [3 /*break*/, 7];
                    case 7:
                        if (!this.reactivateSketchOnSketchComplete) {
                            this.sketchTool.deactivate();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.registerEvent('oncomplete', _this.oncomplete);
        _this.registerEvent('drawEnd', _this.drawEnd);
        return _this;
    }
    LassoToolComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.Graphic])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), Graphic = _a[0];
                        this.sketchTool.oncomplete.subscribe(function () {
                            _this.sketchComplete();
                            _this.drawEnd.emit(_this.sketchTool.geometries);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(LassoToolComponent.prototype, "isActivated", {
        get: function () {
            return this._isActivated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LassoToolComponent.prototype, "sketchTool", {
        get: function () {
            return this.sketchToolRef;
        },
        enumerable: true,
        configurable: true
    });
    LassoToolComponent.prototype.runFeatureQuery = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, e_3, _b, e_4, _c, sublayers, _d, _e, layer, _f, _g, sublayer, sublayers_1, sublayers_1_1, sublayer, clonedSublayer, query, result, layerFeatureResult, e_4_1;
            return tslib_1.__generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        sublayers = [];
                        try {
                            for (_d = tslib_1.__values(this.esriLayers), _e = _d.next(); !_e.done; _e = _d.next()) {
                                layer = _e.value;
                                if (layer.sublayers) {
                                    try {
                                        for (_f = tslib_1.__values(layer.sublayers.items), _g = _f.next(); !_g.done; _g = _f.next()) {
                                            sublayer = _g.value;
                                            sublayers.push(sublayer);
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 6, 7, 8]);
                        sublayers_1 = tslib_1.__values(sublayers), sublayers_1_1 = sublayers_1.next();
                        _h.label = 2;
                    case 2:
                        if (!!sublayers_1_1.done) return [3 /*break*/, 5];
                        sublayer = sublayers_1_1.value;
                        clonedSublayer = sublayer.clone();
                        query = clonedSublayer.createQuery();
                        query.geometry = this.sketchTool.geometries[0];
                        query.outFields = ['*'];
                        query.spatialRelationship = this.spatialRelationship.toLowerCase();
                        query.returnGeometry = true;
                        return [4 /*yield*/, clonedSublayer.queryFeatures(query)];
                    case 3:
                        result = _h.sent();
                        layerFeatureResult = { sublayer: sublayer, featureResults: result.features };
                        if (!result.features) {
                            return [3 /*break*/, 4];
                        }
                        this.layerFeatureResults.push(layerFeatureResult);
                        _h.label = 4;
                    case 4:
                        sublayers_1_1 = sublayers_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_4_1 = _h.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (sublayers_1_1 && !sublayers_1_1.done && (_c = sublayers_1.return)) _c.call(sublayers_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        if (this.displayFeatureGraphicsAfterSpatialQuery) {
                            this.displayFeaturesOnMap();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LassoToolComponent.prototype.runGeoprocessingQuery = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_5, _a, joinedGeometries, joinGeometriesString, dynamicLayerSpatialLayers, results, results_1, results_1_1, result, esriLayer, mapcoreProps, query, queryWithGuidCondition, layerSettings, _b, e_5_1;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.removeGeoProcessingLayers();
                        if (!(this.sketchTool.geometries && this.sketchTool.geometries.length)) return [3 /*break*/, 9];
                        joinedGeometries = { rings: this.sketchTool.geometries[0].rings };
                        joinGeometriesString = JSON.stringify(joinedGeometries);
                        dynamicLayerSpatialLayers = this.esriLayers.map(function (x) { return _this.spatialQueryService.getIDynamicLayerSpatialFromLayer(x); });
                        return [4 /*yield*/, this.spatialQueryService.spatialQuery(true, dynamicLayerSpatialLayers, null, null, null, [joinGeometriesString])];
                    case 1:
                        results = _c.sent();
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 7, 8, 9]);
                        results_1 = tslib_1.__values(results), results_1_1 = results_1.next();
                        _c.label = 3;
                    case 3:
                        if (!!results_1_1.done) return [3 /*break*/, 6];
                        result = results_1_1.value;
                        this.guid = result.guid;
                        esriLayer = this.layerService.getEsriLayerByUniqueId(result.id);
                        mapcoreProps = esriLayer.mapcoreProps;
                        query = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(mapcoreProps.query);
                        queryWithGuidCondition = this.toSqlStringService.addFilter(query, this.spatialQueryService.getGuidQuery(result.guid));
                        layerSettings = { id: mapcoreProps.parentId, query: queryWithGuidCondition, hideInLegend: true };
                        _b = this;
                        return [4 /*yield*/, this.layerService.addMapcoreLayersToMap([layerSettings])];
                    case 4:
                        _b.geoprocessingLayers = _c.sent();
                        _c.label = 5;
                    case 5:
                        results_1_1 = results_1.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_5_1 = _c.sent();
                        e_5 = { error: e_5_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                        }
                        finally { if (e_5) throw e_5.error; }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    LassoToolComponent.prototype.displayFeaturesOnMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_6, _a, e_7, _b, _c, _d, layerFeatureResult, geometryType, symbolDefiniton, _e, _f, feature, graphic;
            return tslib_1.__generator(this, function (_g) {
                try {
                    for (_c = tslib_1.__values(this.layerFeatureResults), _d = _c.next(); !_d.done; _d = _c.next()) {
                        layerFeatureResult = _d.value;
                        geometryType = layerFeatureResult.sublayer.source.dataSource.geometryType;
                        symbolDefiniton = this.themeService.getSymbolDefinitionFromGeometry(geometryType, this.featureLayerColor);
                        try {
                            for (_e = tslib_1.__values(layerFeatureResult.featureResults), _f = _e.next(); !_f.done; _f = _e.next()) {
                                feature = _f.value;
                                graphic = new Graphic({
                                    geometry: feature.geometry,
                                    symbol: symbolDefiniton
                                });
                                this.featuresLayer.add(graphic);
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    LassoToolComponent.prototype.removeGeoProcessingLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.guid = null;
                if (this.mapView && this.geoprocessingLayers) {
                    this.mapView.map.removeMany(this.geoprocessingLayers);
                }
                return [2 /*return*/];
            });
        });
    };
    LassoToolComponent.prototype.sketchComplete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this._isActivated && this.runSpatialQueryOnSketchComplete)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.runSpatialQuery()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.reactivateSketchOnSketchComplete) {
                            this.sketchTool.graphicsLayer.removeAll();
                            this.sketchTool.activate(this.sketchToolType);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LassoToolComponent.prototype.addFeaturesLayerToMapIfNotPresent = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.mapView) return [3 /*break*/, 3];
                        if (!!this.featuresLayer) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: 'Lasso Tool', hideInLegend: true })];
                    case 1:
                        _a.featuresLayer = _b.sent();
                        this.mapView.map.allLayers.on('before-add', function (event) {
                            if (_this.isActivated && event.item.listMode === 'hide') {
                                event.item.set('hideInLegend', true);
                            }
                        });
                        _b.label = 2;
                    case 2:
                        if (!this.mapView.map.allLayers.some(function (x) { return x === _this.featuresLayer; })) {
                            this.mapView.map.add(this.featuresLayer);
                        }
                        this.layerService.moveLayerToTheTop(this.featuresLayer);
                        this.featuresLayer.visible = true;
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], LassoToolComponent.prototype, "runSpatialQueryOnSketchComplete", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], LassoToolComponent.prototype, "reactivateSketchOnSketchComplete", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], LassoToolComponent.prototype, "displayFeatureGraphicsAfterSpatialQuery", void 0);
    return LassoToolComponent;
}(BaseComponent));
export { LassoToolComponent };
